import CacheUtil from '@/assets/utils/CacheUtil'

const app = {
  state: {
    sidebar: {
      opened: !+(localStorage.getItem(CacheUtil.SidebarStatus)||'1'),
      withoutAnimation: false
    },
    device: 'desktop'
  },

  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        localStorage.setItem(CacheUtil.SidebarStatus, 1);
      } else {
        localStorage.setItem(CacheUtil.SidebarStatus, 0);
      }
      state.sidebar.opened = !state.sidebar.opened;
      state.sidebar.withoutAnimation = false;
    },

    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      localStorage.setItem(CacheUtil.SidebarStatus, 1);
      state.sidebar.opened = false;
      state.sidebar.withoutAnimation = withoutAnimation;
    },

    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    }
  },

  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },

    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },

    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    }
  }
}

export default app


// WEBPACK FOOTER //
// ./src/store/modules/app.js